'use client';

import { IconButton } from "@/components/ui/Button/IconButton";
import { useState } from "react";
import "@/styles/sections/header.scss";
import { Button } from "@/components/ui/Button/Button";
import router from "next/router";
import { useLanguage } from '@/context/LanguageContext';
import { PageSwitch } from './PageSwitch';
const MobileHeader = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSelected, setIsSelected] = useState(true);
    const { t } = useLanguage();
    const handleMenu = () => {
        setShowDropdown(!showDropdown);
    };
    return (
        // 모바일 헤더 컴포넌트의 실제 구현
        <div>
            <div className="header-box mobile">
                <div className="header-content">
                    {/* 왼쪽 로고 */}
                    <div className="logo mobile">
                        <img
                            src="/codime-symbol-logotype-black.png"  // 로고 이미지 경로를 실제 경로로 수정해주세요
                            alt="Logo"
                        />
                    </div>

                    <PageSwitch isSelected={isSelected} onSelect={() => {
                        if (isSelected) {
                            window.location.href = 'https://influencer.codime.io/';
                        } else {
                            setIsSelected(!isSelected);
                        }
                    }} />
                    
                    <IconButton
                        fontSize={24}
                        className="gray-500 icon-button-40"
                        iconName={showDropdown ? "icon-icon-x" : "icon-icon-hamburger"}
                        onClick={handleMenu}
                    />
                </div>
                {showDropdown && (
                    <div className="mobile-dropdown">
                        <div className="dropdown-menu">
                            <div className="menu-item">
                                <Button
                                    type="primary2"
                                    label={t.header.contactUs}
                                    icon="none"
                                    size="small"
                                    otherClassName="width-100p btn-radius-100 "
                                    onClick={() => window.open('https://public.relate.so/p/forms/pzst8jlmfdxtahcw', '_blank')}
                                />
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MobileHeader;